<template>
  <div class="tp-page" :class="{ 'tp-page--mobile': isMobile }" dir="rtl">
    <div class="tp-card">
      <header class="tp-head">
        <span class="tp-head__icon"><v-icon size="20" color="primary">mdi-cash-multiple</v-icon></span>
        <div class="tp-head__titles">
          <div class="tp-head__title">{{ id ? $t('translationPriceEdit') : $t('translationPriceNew') }}</div>
          <div class="tp-head__sub">{{ id ? $t('translationPriceEditSub') : $t('translationPriceNewSub') }}</div>
        </div>
        <template v-if="!formType">
          <button type="button" class="tp-tile" :title="$t('translationPriceList')" @click="goTo('translationPriceList')">
            <v-icon size="20">mdi-format-list-bulleted</v-icon>
          </button>
          <button type="button" class="tp-tile" :title="$t('back')" @click="$router.go(-1)">
            <v-icon size="20">mdi-arrow-left</v-icon>
          </button>
        </template>
      </header>
      <v-progress-linear :active="!render || isLoading" indeterminate color="primary" height="2" />

      <v-form v-if="render" ref="form" v-model="valid" lazy-validation class="tp-body">
        <section class="tp-sec">
          <div class="tp-sec__head"><v-icon size="17">mdi-translate</v-icon>{{ $t('translationPriceSecDoc') }}</div>
          <div class="tp-grid tp-grid--3">
            <aicomplete v-model="documentType" title="documentType" type="setConfig" :new-btn="true"
              :rules="[v => !!v || $t('is-required')]"
              :data="JSON.stringify({key:'t_docuemtnType', type:'translation'})" :val="documentType" />
            <aicomplete v-model="fromLanguage" title="fromLanguage" type="setConfig" :new-btn="true"
              :rules="[v => !!v || $t('is-required')]"
              :data="JSON.stringify({key:'t_languages', type:'translation'})" :val="fromLanguage" />
            <aicomplete v-model="toLanguage" title="toLanguage" type="setConfig" :new-btn="true"
              :rules="[v => !!v || $t('is-required')]"
              :data="JSON.stringify({key:'t_languages', type:'translation'})" :val="toLanguage" />
          </div>
        </section>

        <section v-for="sec in sections" :key="sec.key" class="tp-sec">
          <div class="tp-sec__head"><v-icon size="17">{{ sec.icon }}</v-icon>{{ $t(sec.key) }}</div>
          <div class="tp-grid">
            <money v-for="f in sec.fields" :key="f" v-model="$data[f]" :dense="true" :label="$t(f)"
              :outlined="true" :solo="false" value-when-is-empty="" :options="options"
              :hide-details="true" class="tp-money" />
          </div>
        </section>
      </v-form>

      <footer v-if="render" class="tp-foot">
        <v-btn color="primary" depressed class="app-form-action-btn" :loading="isLoading" @click="id ? update() : create()">
          <v-icon small class="me-1">mdi-check</v-icon>{{ $t('submit') }}
        </v-btn>
        <div class="tp-total">
          <span>{{ $t('translationPriceTotal') }}</span>
          <b class="tp-num">{{ $numberFormat(total) }}</b>
        </div>
        <v-btn color="grey" outlined class="app-form-action-btn" @click="goTo('translationPriceList')">
          {{ $t('cancel') }}
        </v-btn>
      </footer>
    </div>
    <snakbar v-model="snakbar" :text="snakbarText" :active="snakbar" :color="snakbarColor" />
  </div>
</template>

<script>
  import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    name: 'Product',
    components: {
      aicomplete,
      Snakbar,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      toLanguage: null,
      fromLanguage: null,
      documentType: null,
      specialTranslat: 0,
      stampTranslator: 0,
      judicialApproval: 0,
      officeServices: 0,
      foreignApproval: 0,
      equalOriginal: 0,
      verificationServices: 0,
      embassy: 0,
      inquiry: 0,
      baseTranslate: 0,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      type: null,
      id: null,
      status: 'active',
      group: null,
      loading: false,
    }),
    computed: {
      sections () {
        return [
          { key: 'translationPriceSecTranslate', icon: 'mdi-file-document-edit-outline', fields: ['baseTranslate', 'specialTranslat', 'stampTranslator', 'equalOriginal'] },
          { key: 'translationPriceSecServices', icon: 'mdi-stamper', fields: ['judicialApproval', 'foreignApproval', 'embassy', 'officeServices', 'verificationServices', 'inquiry'] },
        ]
      },
      total () {
        var app = this
        return this.sections.reduce(function (sum, s) {
          return sum + s.fields.reduce(function (a, k) { return a + (Number(app[k]) || 0) }, 0)
        }, 0)
      },
    },
    watch: {
      snakbar () {
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
      }
    },
    mounted () {
    },
    methods: {
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'translationPrice', app.$data)
          .then(res => {
            app.goTo('translationPriceList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'translationPrice/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.documentType = res.documentType
              app.fromLanguage = res.fromLanguage
              app.toLanguage = res.toLanguage
              app.embassy = res.embassy
              app.inquiry = res.inquiry || 0
              app.baseTranslate = res.fee
              app.foreignApproval = res.foreign_approval
              app.judicialApproval = res.judicial_approval
              app.officeServices = res.office_services
              app.specialTranslat = res.special_translation
              app.stampTranslator = res.stamp_translator
              app.equalOriginal = res.equal_original
              app.verificationServices = res.verification_services
              app.other = res.other
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'translationPrice/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.goTo('translationPriceList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>
.tp-page { padding: 0; height: calc(100vh - 98px); box-sizing: border-box; }
.tp-page ::v-deep .v-input { height: auto !important; }
.tp-card {
  background: #fff; border: 1px solid rgba(15,23,42,.08); border-radius: 6px;
  box-shadow: 0 1px 3px rgba(15,23,42,.05); width: 100%; height: 100%;
  display: flex; flex-direction: column; overflow: hidden;
}
.tp-head { display: flex; align-items: center; gap: 12px; padding: 14px 18px; border-bottom: 1px solid rgba(15,23,42,.07); flex-shrink: 0; }
.tp-head__icon { width: 40px; height: 40px; border-radius: 6px; background: rgba(25,118,210,.1); display: grid; place-items: center; flex-shrink: 0; }
.tp-head__titles { flex: 1; min-width: 0; }
.tp-head__title { font-weight: 700; font-size: 1rem; }
.tp-head__sub { opacity: .6; font-size: .78rem; margin-top: 2px; }
.tp-tile { width: 40px; height: 40px; border-radius: 6px; background: rgba(0,0,0,.05); display: grid; place-items: center; }
.tp-tile:hover { background: rgba(25,118,210,.1); }
.tp-body { flex: 1 1 auto; min-height: 0; background: rgba(0,0,0,.02); overflow-y: auto; overflow-x: hidden; padding: 20px 18px; display: flex; flex-direction: column; gap: 16px; }
.tp-sec { flex-shrink: 0; background: #fff; border: 1px solid rgba(15,23,42,.08); border-radius: 6px; padding: 14px 16px 18px; }
.tp-sec__head { display: flex; align-items: center; gap: 8px; font-weight: 600; font-size: .88rem; margin-bottom: 18px; color: var(--v-primary-base); }
.tp-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 26px 14px; }
.tp-grid--3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.tp-grid > * { margin: 0 !important; min-width: 0; }
.tp-page ::v-deep .tp-money .v-input__slot, .tp-page ::v-deep .tp-sec fieldset { border-radius: 6px !important; }
.tp-page ::v-deep .tp-money input { direction: ltr; text-align: left; }
.tp-foot { display: flex; align-items: center; gap: 12px; padding: 12px 18px; background: #fafbfd; border-top: 1px solid rgba(15,23,42,.07); border-radius: 0 0 6px 6px; flex-shrink: 0; }
.tp-foot ::v-deep .v-btn { border-radius: 6px; }
.tp-total { flex: 1; display: flex; justify-content: center; align-items: baseline; gap: 8px; font-size: .85rem; }
.tp-total span { opacity: .6; }
.tp-num { direction: ltr; font-size: 1.05rem; }
.tp-page--mobile { height: auto; }
.tp-page--mobile .tp-card { max-height: none; border-radius: 0; border: 0; }
.tp-page--mobile .tp-body { padding: 16px; }
.tp-page--mobile .tp-grid, .tp-page--mobile .tp-grid--3 { grid-template-columns: 1fr 1fr; }
.tp-page--mobile .tp-grid--3 { grid-template-columns: 1fr; }
.tp-page--mobile .tp-foot { position: sticky; bottom: 0; }
.theme--dark .tp-card { background: #1e1e1e; border-color: rgba(255,255,255,.1); }
.theme--dark .tp-sec { background: #1e1e1e; }
.theme--dark .tp-head, .theme--dark .tp-sec { border-color: rgba(255,255,255,.1); }
.theme--dark .tp-foot { background: #252525; border-color: rgba(255,255,255,.1); }
.theme--dark .tp-tile { background: rgba(255,255,255,.08); }
@media (max-width: 1000px) { .tp-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>
